<template>
  <div class="tab-container">
    <div
      v-for="(tab, index) in tabs"
      :key="index"
      class="tab"
      :class="{ active: activeIndex === index }"
      @click="setActive(index)"
    >
      {{ tab.content }}
      <div v-if="activeIndex === index" class="underline"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { useRoute } from 'vue-router'

const tabs = ref([])
const activeIndex = ref(0)
const myProps = defineProps(['menusList'])
const myEmits = defineEmits(['categorySelect'])
const route = useRoute()

watch(
  () => route.query.league,
  (newLeague) => {
    if (newLeague) {
      const index = tabs.value.findIndex(tab => tab.content === newLeague)
      if (index !== -1) {
        setActive(index)
      }
    }
  }
)

const setActive = (index) => {
  activeIndex.value = index
  console.log('TabNavigation: 点击tab索引', index)
  console.log('TabNavigation: tabs数组', tabs.value)

  // 使用 tabs.value 数组而不是 myProps.menusList，因为 tabs.value 包含了"全部"选项
  const selectedTab = tabs.value[index]
  console.log('TabNavigation: 选中的tab', selectedTab)

  myEmits('categorySelect', selectedTab)
}
watch(
  () => myProps.menusList,
  (newProps) => {
    if (!newProps || newProps.length === 0) return

    tabs.value = [...newProps] // 使用展开运算符避免直接修改props
    tabs.value.unshift({
      content: '全部',
      id: '',
      sorted: 0,
      leagueIds: null // 使用 null 而不是空字符串
    })

    const league = route.query.league
    if (league) {
      const index = tabs.value.findIndex(tab => tab.content === league)
      if (index !== -1) {
        setActive(index)
        return
      }
    }

    // 如果没有路由参数或找不到对应的tab，默认选中第一个（全部）
    if (activeIndex.value === 0) {
      // 如果当前已经是第一个，手动触发事件
      myEmits('categorySelect', tabs.value[0])
    } else {
      // 否则设置为第一个
      setActive(0)
    }
  },
  { immediate: true }
)
</script>

<style scoped lang="scss">
.tab-container {
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
  background-color: $scoreFootball-tabNavigation-bg;
  border-radius: 12px;
  margin-bottom: 10px;
}

.tab {
  position: relative;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  color: $scoreFootball-tabNavigation-text;
  text-align: center;
  font-weight: 500;
  font-size: 16px;
}

.tab.active {
  color: $scoreFootball-tabNavigation-active;
  font-weight: bold;
}

.underline {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 4px;
  background-color: $scoreFootball-tabNavigation-active;
  border-radius: 10px;
  font-weight: 500;
  font-size: 16px;
}
</style>
